<template lang="pug">
	section(:class="tipo")#filtros
		ul(ref="ul_areas" ).areas
			li(v-for="item, index in areas", @click="changeArea(item)", :class="{ ativo: item == area }").area {{ item }}
			li(@click="changeArea(null)", :class="{ ativo: area == null }").area Todos os Cursos
		form(@submit.prevent).busca
			input(:value="value", @input="$emit('input', $event.target.value)", placeholder="Buscar curso")
</template>

<script>
export default {
	name: "section-filtros",
	props: {
		value: {
			type: String
		},
		areas: {
			type: Array
		},
		tag: {
			type: String
		},
		sort: {
			type: String
		}
	},
	computed: {
		tipo() {
			return this.$route.params.tipo
		},
		area: {
			get() {
				return this.tag
			},
			set(value) {
				this.$emit('update:tag', value)
			}
		},
		ordenacao: {
			get() {
				return this.sort
			},
			set(value) {
				this.$emit('update:sort', value)
			}
		},
	},
	methods: {
		changeArea(area) {
			this.area = area
			this.$emit('input', '')
		}
	},
}
</script>

<style lang="stylus" scoped src="./Filtros.styl"></style>
